import { getCurrentInstance, computed } from "vue";
const filterComponentProps = (childProps) => {
  const { props } = getCurrentInstance();
  return computed(() => {
    return Object.keys(childProps).reduce((acc, propName) => {
      acc[propName] = props[propName];
      return acc;
    }, {});
  });
};
export {
  filterComponentProps as f
};
//# sourceMappingURL=filter-props-9727421a.mjs.map
